import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import { NzModalService, NzModalRef } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SparepartsService } from '../../service/spareparts.service';
// import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { SpareListComponent } from '../spareparts-management/spare-list/spare-list.component';
import { ProviderService } from '../../service/provider.service';
@Component({
  selector: 'app-entry-detail',
  templateUrl: './entry-detail.component.html',
  styleUrls: ['./entry-detail.component.less']
})
export class EntryDetailComponent implements OnInit {

  validateForm: FormGroup;
  selectedValue: string;
  listOfData: ItemData[] = [];
  editId: string | null = null;
  deliver: string;
  entryNo: string;
  uploading = false;
  loading = false;
  canSave = false;
  contracts = [];
  sparesImportModal?: NzModalRef;

  @Input() entryTypes: any;
  @Input() no: string;
  @Input() typeId: number;
  @Input() shr: string;
  @Input() cid: string;
  constructor(
    private fb: FormBuilder,
    private modalRef: NzModalRef,
    private modal: NzModalService,
    public message: NzMessageService,
    private dataService: SparepartsService,
    private providerService: ProviderService,
  ) { }

  ngOnInit(): void {
    this.providerService.getProviderContracts().subscribe((data: any) => {
      this.contracts = data;
    });
    if (this.no != null) {
      this.canSave = true;
      this.validateForm = this.fb.group({
        typeId: new FormControl({ value: this.typeId + '', disabled: true }, Validators.required),
        entryNo: new FormControl({ value: this.no, disabled: true }, Validators.required),
        deliver: new FormControl({ value: this.shr, disabled: true }, Validators.required),
        cid: new FormControl({ value: Number(this.cid), disabled: true }, Validators.required), // 合同id
      });
      this.entryNo = this.no;
      this.selectedValue = this.typeId + '';
      this.deliver = this.shr;
      this.queryEntryDetailData();
    } else {
      // this.validateForm = this.fb.group({ typeId: null, entryNo: null, deliver: null });
      this.initEntryNo();
      this.validateForm = this.fb.group({
        typeId: new FormControl({ value: null, disabled: false }, Validators.required),
        entryNo: new FormControl({ value: this.entryNo, disabled: true }, Validators.required),
        deliver: new FormControl({ value: null, disabled: false }, Validators.required),
        cid: new FormControl({ value: null, disabled: false })
      });
    }

  }



  initEntryNo() {
    const nowstr = new Date();
    this.entryNo = nowstr.getFullYear()
      + ((nowstr.getMonth() + 1) < 10 ? '0' : '') + (nowstr.getMonth() + 1)
      + (nowstr.getDate() < 10 ? '0' : '') + nowstr.getDate()
      + (nowstr.getHours() < 10 ? '0' : '') + nowstr.getHours()
      + (nowstr.getMinutes() < 10 ? '0' : '') + nowstr.getMinutes()
      + (nowstr.getSeconds() < 10 ? '0' : '') + nowstr.getSeconds();
  }



  addSpare() {
    const modal = this.modal.create({
      nzTitle: '备件列表',
      nzContent: SpareListComponent,
      nzStyle: { top: '40px' },
      nzWidth: 800,
      nzMaskClosable: false,
      nzFooter: null,
      nzComponentParams: {
        code: 1, // code 0 备件只能查看，不能选择 code 1 备件可以查看 也可以被选中
      }
    });
    modal.afterClose.subscribe(
      {
        next: items => {
          // console.log(items);
          if (items != null && items !== undefined) {
            items.forEach(element => {
              const index = this.listOfData.findIndex((a) => a.spNo === element.spNo);
              if (index < 0) {
                this.listOfData = [
                  ...this.listOfData,
                  {
                    spNo: element.spNo,
                    spName: element.spName,
                    amount: 0,
                    price: element.price,
                    unit: element.unit,
                    total: 0,
                    desc: element.mark
                  }
                ];
              }

            });
          }

        }
      }
    );
  }

  createSparesImportModal(tplTitle: TemplateRef<{}>, tplContent: TemplateRef<{}>, tplFooter: TemplateRef<{}>) {

    this.sparesImportModal = this.modal.create({
      nzTitle: tplTitle,
      nzContent: tplContent,
      nzFooter: tplFooter,
      nzMaskClosable: false,
      nzClosable: false,
      nzComponentParams: {
        value: 'Template Context'
      },
      nzOnOk: () => console.log('Click ok')
    });

  }

  cancelSparesImport() {
    this.sparesImportModal.destroy();
  }

  uploadSparesFile($event) {

    const target: DataTransfer = ($event.target) as DataTransfer;
    if (target.files.length !== 0) {
      if (target.files.length !== 1) { throw new Error('Cannot use multiple files'); }
    }

    const reader: FileReader = new FileReader();

    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      //const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary', cellDates: true, dateNF: 'yyyy/MM/dd' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      let sparesDataToImport = XLSX.utils.sheet_to_json(ws, { raw: false });

      let data: ItemData[] = [];

      for (let i = 0; i < sparesDataToImport.length; i++) {

        let itemTmp = sparesDataToImport[i];

        let a = itemTmp["备件"];
        let b = itemTmp["数量"];
        let c = itemTmp["单位"];
        let d = itemTmp["单价"];

        if (a === undefined || b === undefined || c === undefined || d === undefined) {
          this.message.create('warning', '导入excel数据有误，请仔细检查文件!');
          this.sparesImportModal.destroy();
          return;
        }

        let spNo = itemTmp["备件"].substring(0, itemTmp["备件"].indexOf("-"));
        let spName = itemTmp["备件"].substring(itemTmp["备件"].indexOf("-") + 1, itemTmp["备件"].indexOf(","));

        data.push({
          spNo: spNo,
          spName: spName,
          amount: itemTmp['数量'],
          price: itemTmp['单价'],
          unit: itemTmp['单位'],
          total: itemTmp['数量'] * itemTmp['单价'],
          desc: itemTmp['备注']
        });
      }

      if (data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          this.listOfData = [
            ...this.listOfData,
            data[i]
          ];
        }
      }

      this.sparesImportModal.destroy();

    };
    reader.readAsBinaryString(target.files[0]);

  }

  async queryEntryDetailData() {
    this.loading = true;
    const result = await this.dataService.queryEntryDetailData(this.no);
    this.loading = false;
    if (result.code !== 200) {
      this.message.create('error', '查询入库单详情失败!');
      return;
    } else {
      result.data.forEach(element => {
        element.total = element.price * element.amount;
      });
      this.listOfData = result.data;
    }
  }
  exportForm() {
    if (this.listOfData == null || this.listOfData.length === 0) {
      return;
    }
    const dataToExport: any[] = [];
    let index = 0;
    this.listOfData.forEach(e => {
      index = index + 1;
      const item = {
        '序号': index,
        '备件名称': e.spName,
        '数量': e.amount,
        '单位': e.unit,
        '单价': e.price,
        '总金额': e.total,
        '备注': e.desc
      };
      dataToExport.push(item);
    });
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook: XLSX.WorkBook = { Sheets: { '入库单': worksheet }, SheetNames: ['入库单'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data: Blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    const nowstr = new Date();
    const datenow = nowstr.getFullYear()
      + ((nowstr.getMonth() + 1) < 10 ? '0' : '') + (nowstr.getMonth() + 1)
      + (nowstr.getDate() < 10 ? '0' : '') + nowstr.getDate()
      + (nowstr.getHours() < 10 ? '0' : '') + nowstr.getHours()
      + (nowstr.getMinutes() < 10 ? '0' : '') + nowstr.getMinutes()
      + (nowstr.getSeconds() < 10 ? '0' : '') + nowstr.getSeconds();
    // FileSaver.saveAs(data, '入库单' + '_' + datenow + '.xlsx');
  }
  deleteRow(id: number): void {
    this.listOfData = this.listOfData.filter(d => d.spNo !== id);
  }
  startEdit(id: string): void {
    this.editId = id;
  }

  stopEdit(data: any): void {
    if (data.amount < 0) {
      data.amount = 0;
    }
    data.total = data.amount * data.price;
    this.editId = null;
  }

  async saveEntryData() {
    if (this.entryNo == null || this.entryNo === undefined ||
      this.entryNo.toString() === '') {
      this.message.create('warning', '请输入入库单号!');
      return;
    }
    if (this.validateForm.value.typeId == null || this.validateForm.value.typeId === undefined ||
      this.validateForm.value.typeId.toString() === '') {
      this.message.create('warning', '请选择入库类型!');
      return;
    }
    if (this.validateForm.value.deliver == null || this.validateForm.value.deliver === undefined) {
      this.deliver = '';
      this.validateForm.value.deliver = '';
    } else {
      if (this.validateForm.value.deliver.trim().length > 10) {
        this.message.create('warning', '送货人长度不能大于10!');
        return;
      }
    }
    if (this.listOfData == null || this.listOfData.length === 0) {
      this.message.create('warning', '请添加备件信息!');
      return;
    }
    if (!this.listOfData.every(data => data.amount > 0)) {
      this.message.create('warning', '备件数量不能等于0!');
      return;
    }
    if (!this.listOfData.every(data => (data.desc == null || data.desc === undefined || data.desc.trim().length <= 50))) {
      this.message.create('warning', '备件的备注信息字数不能大于50!');
      return;
    }
    this.modal.confirm({
      nzTitle: '<i>确认入库备件数量等信息无误并创建入库单？</i>',
      // nzContent: '<b>保存？</b>',
      nzOnOk: () => this.saveEntryDataInfo()
    });
  }
  async saveEntryDataInfo() {
    this.uploading = true;
    const result = await this.dataService.uploadSparePartsData(
      this.entryNo, this.validateForm.value.typeId, this.validateForm.value.deliver, this.validateForm.value.cid, this.listOfData);
    this.uploading = false;
    if (result === null) {
      this.message.create('error', '入库失败!');
    } else {
      this.message.create('success', '入库成功!');
      this.modalRef.destroy('success');
    }
  }
  cancleEntryData() {
    this.modalRef.destroy('cancle');
  }

}
interface ItemData {
  spNo: number;
  spName: string;
  amount: number;
  unit: string;
  price: number;
  total: number;
  desc: string;
}
